export const apiEndpoints = {
    LOGIN: '/users/login/',
    FORGOT_PASSWORD: '/users/forgot-password/',
    RESET_PASSWORD: '/users/reset-password/',
    CHANGE_PASSWORD: '/users/password/change/',
    GET_COMPANIES: '/buyer_information_finder/companies/',
    GET_SINGLE_COMPANY: id => `/buyer_information_finder/company/${id}/`,
    GET_EMPLOYEES: '/buyer_information_finder/employees/',
    ADD_TO_CONTACT: '/buyer_information_finder/contacts/add/',
    GET_CONTACTS: '/buyer_information_finder/contacts/',
    GET_USER: '/users/me/',
    UPDATE_USER: '/users/update/',
    DELETE_CONTACT: `/buyer_information_finder/contacts/delete/`,
    EXPORT_CSV: '/buyer_information_finder/export-employees/',
    GET_TEAMS: '/teams/members/',
    ADD_TEAM_MEMBER: '/teams/member/invite/',
    RESEND_INVITE: '/teams/member/resend-invite/',
    ADD_THRIVE_CART_USER: '/users/thrive-cart/invite/',
    ACCEPT_TEAM_INVITE: '/users/team-member/accept-invitation/',
    ACCEPT_THRIVE_CARD_INVITE: '/users/thrive-cart/accept-invitation/',
    DELETE_TEAM_MEMBER: id => `/teams/member/remove/${id}/`,
    GET_FILTERS: '/buyer_information_finder/filters/',
    COMPANY_REQUEST: '/buyer_information_finder/company-request/',
    GET_BUSINESS_TYPES: '/buyer_information_finder/business-types/',
};
